import { Card, Text, BlockStack } from '@shopify/polaris';

export function StatCard({
  title,
  value,
  hint,
}: {
  title: string;
  value: string;
  hint?: string;
}) {
  return (
    <Card>
      <BlockStack gap="100">
        <Text as="p" tone="subdued" variant="bodySm">
          {title}
        </Text>
        <Text as="p" variant="headingLg">
          {value}
        </Text>
        {hint ? (
          <Text as="p" tone="subdued" variant="bodySm">
            {hint}
          </Text>
        ) : null}
      </BlockStack>
    </Card>
  );
}
